import { Button } from '~/shared/ui/button';

import { useLogout } from '../lib';

export function LogoutButton() {
  const { handleLogout } = useLogout();

  return (
    <Button width="full" variant="secondary" onClick={() => handleLogout()}>
      Logout
    </Button>
  );
}
